import React from 'react';

function FullBodyItem(props) {
  return (
    <div className="sub-section-item">
      <div className="display-flex">
        <div className="user-image">
          <img src={props.myGroupIcon} alt="" />
        </div>
        <div className="user-name-and-email">
          <div className="font10">{props.details[props.position].title}</div>
          <span className="primary-text font10">{props.details[props.position].participants}</span>
        </div>
      </div>

      <div className="sub-section-people-strip ">
        <div className={'sub-section-people-strip-arrow-icon ' + props.arrowDisplay}>
          <img src="/static/images/icons/home/icon_arrow_left.png" />
        </div>

        <div className="sub-section-people-strip-icons">
          {props.iconArray.map((val, key) => (
            <div key={key} className="sub-section-people-strip-icon">
              <img src={val.icon} alt="" />
            </div>
          ))}
        </div>

        <div className={'sub-section-people-strip-arrow-icon ' + props.arrowDisplay}>
          <img src="/static/images/icons/home/icon_arrow_right.png" />
        </div>
      </div>
    </div>
  );
}

export default FullBodyItem;



// WEBPACK FOOTER //
// ./src/features/themes/my-account/MainTabsBodyMyGroups/components/FullBodyItem.js